{
  "nm": "Nebula",
  "ddd": 0,
  "h": 300,
  "w": 300,
  "meta": {
    "a": "SVGator",
    "d": "SVGator, the ultimate SVG animation generator now supports Lottie: a thoughtfully designed, intuitive interface, right at your fingertips.",
    "g": "Made in SVGator (https://www.svgator.com/)"
  },
  "layers": [
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [114.344002, 57.251999] },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [160.661207, 107.754323] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "",
          "it": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "d": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [196.933, 76.0448],
                              [228.211433, 57.032891],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 0
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [200.592251, 98.483309],
                              [228.280663, 88.296195],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 10
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [200.421852, 98.168044],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 30
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.66, 87.9443],
                              [195.759338, 83.561763],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.66, 87.9443]
                            ]
                          }
                        ],
                        "t": 40
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-9.035089, 0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [9.03509, -0.049191],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 50
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.509719, 1.188692],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.509719, -1.188692],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.664968, 75.380705],
                              [228.305803, 78.0314],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 60
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-10.020005, 17.499657],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [10.020005, -17.499657],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.280663, 65.987516],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 70
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-13.750305, 25.651364],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [13.750305, -25.651364],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [195.759338, 83.561763],
                              [228.280663, 56.226448],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 80
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-11.117096, 13.039305],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [11.117096, -13.039305],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [203.452065, 64.2523],
                              [228.211433, 53.467391],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 85
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.483887, 0.427246],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.483887, -0.427246],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [197.710582, 99.730473],
                              [228.211433, 88.723782],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 90
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.483887, 0.427246],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.483887, -0.427246],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [197.710582, 99.730473],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 140
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-7.294903, 7.053448],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [7.294903, -7.053448],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [201.713312, 73.810873],
                              [228.688, 71.458433],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 150
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-17.333227, 15.90442],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [17.333227, -15.90442],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [201.713312, 73.810873],
                              [228.211433, 57.102698],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 160
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.610901, 14.004044],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.610901, -14.004044],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.61863, 70.034269],
                              [228.688, 56.030226],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 165
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-7.13149, 1.076197],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [7.13149, -1.076197],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.5496, 96.811753],
                              [228.280663, 88.296195],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 170
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-6.144423, 1.680234],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [6.144423, -1.680234],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.5496, 96.811753],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 200
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-12.676108, -3.444318],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [12.676108, 3.444318],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.341076, 81.491604],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 210
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.601296, 3.057571],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.601296, -3.057571],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [200.661795, 71.841595],
                              [228.305803, 64.482833],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 220.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-1.871758, 12.567436],
                              [-2.05415, -0.627678],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [1.871758, -12.567436],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.501436, 76.666599],
                              [228.211433, 63.530934],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 229.99999999999997
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 21.869454],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, -21.869454],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.341076, 81.491604],
                              [228.211433, 58.207141],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 240
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-2.392664, 10.934728],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [2.392664, -10.934726],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [208.647233, 68.257974],
                              [228.211434, 52.568473],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 245.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.785328, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.785328, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [206.780818, 96.300395],
                              [228.211433, 88.296195],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 250
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.511298, 84.461665],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 270
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [4.718701, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [207.511298, 84.461665],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 280
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-8.507694, -4.708898],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [8.507694, 4.708898],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [204.172662, 78.902933],
                              [228.305803, 87.913033],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 290
                      },
                      {
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [-13.195119, 21.207587],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [13.195119, -21.207587],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [171.853883, 83.405694],
                              [200.338761, 84.153604],
                              [228.280663, 63.528604],
                              [228.688, 3.16819],
                              [171.66, 3.16819],
                              [171.66, 64.2523],
                              [171.66, 73.0016],
                              [171.853883, 83.405694]
                            ]
                          }
                        ],
                        "t": 300
                      }
                    ]
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "c": { "a": 0, "k": [0.0549, 0.3451, 0.6627] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [200.174004, 45.556244] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [200.651573, 45.461875] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "d": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.090836, -6.249354],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.702515, -5.830291],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [-0.009487, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [70.999811, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 0
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.520628, -4.78026],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.326866, -4.114698],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [0.070328, 106.28584],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [70.999811, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 10
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [19.95042, -3.311167],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [25.4062, 112.901],
                              [0.070328, 112.901],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [150.592855, 96.8702],
                              [70.999811, 96.8702],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 20
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 101.221],
                              [24.210735, 102.744033],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [141.622497, 90.987033],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 40
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [4.769693, -6.208641],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-7.289797, 3.284145],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 108.318981],
                              [23.608475, 109.586969],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 50
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.478096, -12.717008],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-10.641308, -6.039975],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 112.3667],
                              [11.676253, 117.805489],
                              [0.070328, 102.744033],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 60
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.936935, -17.781818],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-11.881778, -4.276412],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 107.309238],
                              [15.79562, 119.41009],
                              [0.070328, 122.623433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 70
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.267684, 0.781051],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.675808, 116.138013],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 80
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.675808, 116.138013],
                              [0.070328, 115.258806],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 100
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869794, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.760022, 112.887623],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 110.00000000000001
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [9.869793, -5.920348],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-14.119957, 5.613758],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 102.251775],
                              [22.844237, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 120
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.031508, 1.432323],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-10.067914, 1.14353],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 106.722003],
                              [21.973057, 106.722003],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 130
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-18.138617, -4.475757],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 111.192231],
                              [9.232286, 120.280626],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [140.659812, 90.987033],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 140
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 119.449125],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 150
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 119.449125],
                              [0.070328, 116.138013],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 160
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [15.323507, -0.31535],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 115.381729],
                              [0.070328, 112.001773],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 170
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [11.762661, -16.705092],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.015872, -3.326698],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 105.001568],
                              [21.966607, 111.314333],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 180
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [18.181996, -3.128698],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.71321, -1.942106],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 107.865533],
                              [26.047907, 107.865533],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 190
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [14.601685, -18.028851],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 112.434913],
                              [6.669004, 120.280626],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [141.660015, 91.275826],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 200
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [18.541578, 118.742351],
                              [0.070328, 122.623433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 210
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 220.00000000000003
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 229.99999999999997
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 111.314333],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 240
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.281313, 119.991833],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 250
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 260
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 270
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [12.630557, -16.206076],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-4.728873, -3.548622],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.386528, 104.342874],
                              [23.15625, 109.637233],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 280
                      },
                      {
                        "o": { "x": 0.167, "y": 0.167 },
                        "i": { "x": 0.833, "y": 0.833 },
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0.802171, -8.721565],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-18.718848, -1.346894],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.305711, 105.620689],
                              [29.354941, 129.682826],
                              [0.070328, 107.865533],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [76.862189, 102.251775],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 290
                      },
                      {
                        "s": [
                          {
                            "c": true,
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [0.000506, -4.9168],
                              [0, 0],
                              [0, 0],
                              [-20.1613, 0],
                              [-7.7759, -7.20047],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [17.211577, 3.397387],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [-6.180296, 1.7717],
                              [0, 0],
                              [0, 0],
                              [0, -22.4657],
                              [8.9283, 0],
                              [0, 0],
                              [0, 0],
                              [0, 0],
                              [-21.951217, -2.399106],
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [57.306713, 84.404033],
                              [57.3162, 92.413],
                              [57.3162, 107.865533],
                              [42.283633, 126.587801],
                              [0.070328, 128.003433],
                              [0, 36.2906],
                              [32.5462, 0],
                              [56.1636, 10.0807],
                              [121.748, 69.9399],
                              [130.613, 78.0314],
                              [146.407911, 93.708584],
                              [75.301321, 100.267585],
                              [64.680855, 90.987033],
                              [57.306713, 84.404033]
                            ]
                          }
                        ],
                        "t": 300
                      }
                    ]
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "c": { "a": 0, "k": [0.0549, 0.3451, 0.6627] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [75.626503, 57.251999] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [75.626507, 57.251999] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 1
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [-2.379581, 1.418099] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 220.00000000000003
            },
            { "s": [70, 70], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [26.514628, 161.999141],
              "t": 0,
              "ti": [-4.051193, -5.665866],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [25.371695, 176.724061],
              "t": 20,
              "ti": [-9.40096, 0],
              "to": [4.051193, 5.665866]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [42.245659, 183.131945],
              "t": 40,
              "ti": [0, 0],
              "to": [9.40096, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [78.129078, 183.761569],
              "t": 60,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [100.292075, 182.159686],
              "t": 80
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [125.507503, 179.34852],
              "t": 100
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [150.185173, 175.336236],
              "t": 120
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [194.077866, 164.884],
              "t": 140,
              "ti": [-7.883025, 2.38324],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [263.202197, 142.460346],
              "t": 150,
              "ti": [0.455857, 5.51645],
              "to": [7.883025, -2.38324]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [276.733682, 128.166446],
              "t": 160,
              "ti": [0, 0],
              "to": [-0.455857, -5.51645]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [263.004171, 117.774761],
              "t": 180,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [238.424233, 116.106676],
              "t": 200,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [205.780413, 117.774761],
              "t": 220.00000000000003
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [180.538913, 121.190846],
              "t": 240,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [145.27828, 128.166446],
              "t": 260,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.42, "y": 0 },
              "i": { "x": 1, "y": 1 },
              "s": [115.95502, 134.136446],
              "t": 280,
              "ti": [11.937822, -8.507923],
              "to": [-11.837168, 2.188069]
            },
            { "s": [26.514628, 161.999141], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 2
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 220.00000000000003
            },
            { "s": [50, 50], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 0,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [157.464487, 128.455241],
              "t": 20,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.95502, 134.136446],
              "t": 40,
              "ti": [13.303734, -1.203314],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [64.825344, 143.66366],
              "t": 60,
              "ti": [5.212522, -3.625478],
              "to": [-13.303734, 1.203314]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 161.999141],
              "t": 80,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [21.607135, 175.419953],
              "t": 100,
              "ti": [-15.375775, -1.229676],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 120,
              "ti": [0, 0],
              "to": [15.375775, 1.229677]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 140,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [99.827552, 182.233981],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [126.820634, 179.072848],
              "t": 160
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [150.185173, 175.336236],
              "t": 180
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 200,
              "ti": [-11.972887, 10.49305],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [268.081569, 138.298396],
              "t": 220.00000000000003,
              "ti": [-1.748648, 3.538238],
              "to": [2.573348, -1.537889]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [276.733682, 128.166446],
              "t": 240,
              "ti": [13.638631, 3.416085],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [263.004171, 117.774761],
              "t": 260,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 280,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            { "s": [180.538913, 121.190846], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 3
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [2.357611, 1.612885] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [75, 75],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 220.00000000000003
            },
            { "s": [75, 75], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [279.097823, 135.001313],
              "t": 0,
              "ti": [0.413098, 1.704608],
              "to": [4.185391, -2.313861]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [281.92891, 122.638903],
              "t": 10,
              "ti": [4.372994, 1.095309],
              "to": [-0.428169, -1.621483]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [275.006207, 116.395471],
              "t": 20,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 40,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [205.965586, 117.774761],
              "t": 60,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 80,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [145.27828, 128.166446],
              "t": 100,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.95502, 134.136446],
              "t": 120,
              "ti": [11.81006, -4.16195],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [66.319018, 142.460346],
              "t": 140,
              "ti": [5.212522, -3.625478],
              "to": [-11.81006, 4.16195]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 160.646772],
              "t": 150,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [20.428567, 179.072848],
              "t": 160,
              "ti": [-8.150653, 0],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 180,
              "ti": [0, 0],
              "to": [8.150653, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 200,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [98.810855, 182.233981],
              "t": 220.00000000000003
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [128.381632, 179.25954],
              "t": 240
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [150.185173, 175.336236],
              "t": 260
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 280,
              "ti": [-11.568804, 13.078819],
              "to": [23.636028, -6.696923]
            },
            { "s": [279.097823, 135.771223], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 4
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [0, 0] },
        "s": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [100, 100],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [74.6314, 74.6314],
              "t": 80
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [50, 50],
              "t": 150
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [70, 70],
              "t": 220.00000000000003
            },
            { "s": [100, 100], "t": 300 }
          ]
        },
        "sk": { "a": 0, "k": 0 },
        "p": {
          "a": 1,
          "k": [
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [126.310855, 179.864195],
              "t": 0
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [162.37138, 175.625031],
              "t": 20
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [194.077866, 164.884],
              "t": 40,
              "ti": [-6.767305, 2.646525],
              "to": [23.636028, -6.696923]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [248.861955, 149.337663],
              "t": 60,
              "ti": [-7.38812, 14.2939],
              "to": [14.142216, -6.877317]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [276.733682, 128.166446],
              "t": 80,
              "ti": [13.638631, 3.416085],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [263.004171, 117.774761],
              "t": 100,
              "ti": [11.792437, -0.302814],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [238.424233, 116.106676],
              "t": 120,
              "ti": [0, 0],
              "to": [-11.792436, 0.302813]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [205.965586, 117.774761],
              "t": 140,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [180.538913, 121.190846],
              "t": 150,
              "ti": [0, 0],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [145.27828, 128.166446],
              "t": 160,
              "ti": [11.837168, -2.188069],
              "to": [0, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [115.054804, 134.136446],
              "t": 180,
              "ti": [11.81006, -4.16195],
              "to": [-11.837168, 2.188069]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [66.319018, 142.460346],
              "t": 200,
              "ti": [5.212522, -3.625478],
              "to": [-11.81006, 4.16195]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [27.067209, 158.923396],
              "t": 220.00000000000003,
              "ti": [-5.746212, -4.890248],
              "to": [-5.212522, 3.625478]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [25.004709, 179.25954],
              "t": 240,
              "ti": [-8.003723, 0],
              "to": [5.746212, 4.890248]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [42.245659, 183.131945],
              "t": 260,
              "ti": [0, 0],
              "to": [8.003723, 0]
            },
            {
              "o": { "x": 0.167, "y": 0.167 },
              "i": { "x": 0.833, "y": 0.833 },
              "s": [78.129078, 183.761569],
              "t": 280,
              "ti": [0, 0],
              "to": [0, 0]
            },
            { "s": [126.152713, 179.882138], "t": 300 }
          ]
        },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "el",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "p": { "a": 0, "k": [0, 0] },
          "s": { "a": 0, "k": [55, 55] }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 5
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [136.039184, 36.831344] },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [157.455804, 151.335385] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "gr",
          "bm": 0,
          "hd": false,
          "nm": "",
          "it": [
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-12.614, 1.09758],
                        [0, 0],
                        [17.985, -2.74654]
                      ],
                      "o": [
                        [0, 0],
                        [14.724, -2.1903],
                        [0, 0],
                        [-15.432, 0.943064],
                        [0, 0]
                      ],
                      "v": [
                        [146.067, 5.523],
                        [155.301, 13.9512],
                        [196.55, 9.01352],
                        [196.55, 0],
                        [146.067, 5.523]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [171.308502, 6.9756] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [171.308502, 6.9756] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.3645, -0.5846]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [-2.4452, 0.5757],
                        [0, 0]
                      ],
                      "v": [
                        [82.2063, 28.2451],
                        [82.2063, 19.9212],
                        [89.4223, 26.5042],
                        [82.2063, 28.2451]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [85.814301, 24.08315] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [85.814301, 24.08315] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "gr",
              "bm": 0,
              "hd": false,
              "nm": "",
              "it": [
                {
                  "ty": "sh",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "d": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "c": true,
                      "i": [
                        [0, 0],
                        [-16.6208, 7.8663],
                        [0, 0],
                        [-0.5815, -3.2978],
                        [-8.3059, -1.0951],
                        [-24.6127, 2.3884],
                        [-14.859, 2.3299],
                        [-5.34, 0.9417],
                        [-15.107, 3.6992],
                        [-2.31, 0.5942],
                        [-10.73, 6.1753],
                        [0.457, 2.591],
                        [5.029, 1.16506],
                        [0, 0],
                        [-0.856, -4.85335],
                        [12.58, -6.7591],
                        [48.314, -8.5192],
                        [2.661, -0.436],
                        [15.674, -1.181],
                        [14.4042, 1.964],
                        [1.011399, 5.7359]
                      ],
                      "o": [
                        [-1.144041, -6.4882],
                        [0, 0],
                        [-9.2947, 4.4251],
                        [0.5179, 2.9374],
                        [12.4952, 1.6474],
                        [12.9119, -1.2529],
                        [5.182, -0.8126],
                        [17.723, -3.125],
                        [2.396, -0.5866],
                        [25.962, -6.6798],
                        [5.811, -3.3448],
                        [-0.394, -2.2331],
                        [0, 0],
                        [10.94, 2.19345],
                        [0.988, 5.6026],
                        [-22.709, 12.2007],
                        [-2.695, 0.4752],
                        [-17.973, 2.9437],
                        [-23.0744, 1.7386],
                        [-14.7352, -2.0091],
                        [0, 0]
                      ],
                      "v": [
                        [0.094341, 60.4258],
                        [24.8901, 38.2612],
                        [24.8901, 46.8315],
                        [11.1685, 58.6354],
                        [24.8901, 64.6723],
                        [82.2063, 63.5206],
                        [124.101, 58.1406],
                        [139.894, 55.509],
                        [189.49, 45.1544],
                        [196.55, 43.3827],
                        [253.578, 23.4302],
                        [261.926, 14.4201],
                        [253.578, 9.32804],
                        [253.578, 1.89143],
                        [271.984, 12.4843],
                        [253.578, 31.4344],
                        [141.057, 64.9112],
                        [133.021, 66.2779],
                        [82.2063, 72.4539],
                        [24.8901, 72.0808],
                        [0.094341, 60.4258]
                      ]
                    }
                  }
                },
                {
                  "ty": "fl",
                  "bm": 0,
                  "hd": false,
                  "nm": "",
                  "c": { "a": 0, "k": [0.0863, 0.2275, 0.451] },
                  "r": 2,
                  "o": { "a": 0, "k": 100 }
                },
                {
                  "ty": "tr",
                  "a": { "a": 0, "k": [136.039184, 37.777058] },
                  "s": { "a": 0, "k": [100, 100] },
                  "sk": { "a": 0, "k": 0 },
                  "p": { "a": 0, "k": [136.120001, 37.777058] },
                  "r": { "a": 0, "k": 0 },
                  "sa": { "a": 0, "k": 0 },
                  "o": { "a": 0, "k": 100 }
                }
              ]
            },
            {
              "ty": "tr",
              "a": { "a": 0, "k": [0, 0] },
              "s": { "a": 0, "k": [100, 100] },
              "sk": { "a": 0, "k": 0 },
              "p": { "a": 0, "k": [0, 0] },
              "r": { "a": 0, "k": 0 },
              "sa": { "a": 0, "k": 0 },
              "o": { "a": 0, "k": 100 }
            }
          ]
        }
      ],
      "ind": 6
    },
    {
      "ty": 4,
      "nm": "",
      "sr": 1,
      "st": 0,
      "op": 300,
      "ip": 0,
      "hd": false,
      "ddd": 0,
      "bm": 0,
      "hasMask": false,
      "ao": 0,
      "ks": {
        "a": { "a": 0, "k": [249.6505, 217.58] },
        "s": { "a": 0, "k": [100, 100] },
        "sk": { "a": 0, "k": 0 },
        "p": { "a": 0, "k": [295.966707, 268.248792] },
        "r": { "a": 0, "k": 0 },
        "sa": { "a": 0, "k": 0 },
        "o": { "a": 0, "k": 100 }
      },
      "ef": [],
      "shapes": [
        {
          "ty": "sh",
          "bm": 0,
          "hd": false,
          "nm": "",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [-20.161596, 0],
                [-7.776269, -7.200461],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [20.161596, 0],
                [8.064364, 7.488094],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, -22.465704],
                [8.928373, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 22.177566],
                [-8.928648, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [57.316662, 195.853815],
                [0, 195.853815],
                [0, 36.290625],
                [32.546603, 0],
                [56.164283, 10.080691],
                [171.661433, 115.490426],
                [171.661433, 3.168189],
                [228.69, 3.168189],
                [228.69, 163.019604],
                [196.143535, 199.31],
                [172.23808, 188.653355],
                [57.316662, 83.814078],
                [57.316662, 195.853815]
              ]
            }
          }
        },
        {
          "ty": "fl",
          "bm": 0,
          "hd": false,
          "nm": "",
          "c": { "a": 0, "k": [0.0549, 0.3451, 0.6627] },
          "r": 2,
          "o": { "a": 0, "k": 100 }
        }
      ],
      "ind": 7
    }
  ],
  "v": "5.5.2",
  "fr": 100,
  "op": 300,
  "ip": 0,
  "assets": []
}
